import "rxjs-compat";
import { of, from } from "rxjs";
import { tap, ignoreElements, mergeMap } from "rxjs/operators";
import { ofType, combineEpics } from "redux-observable";
import { innerLoadLoadingLoadedEpic } from "@ane/core/lib/utils/ReduxObservablesEpicUtils";
import FeatureResources from "@ane/exp-data/lib/resources/FeatureResources";
import { flightActionTypes, loadingFlights, loadingFlight, loadedFlight, loadedFlights } from "../ducks/Flights.ducks.js";
import logger, { ErrorType } from "@ane/core/lib/services/logging/Logger";
import { AsyncRequestStatus } from "@ane/core/lib/models";
const FlightErrorEpic = (action$) => {
  return action$.pipe(
    ofType(...Object.values(flightActionTypes)),
    tap(({ error }) => {
      if (!!error) {
        logger.error(error, ErrorType.FlightEpics);
      }
    }),
    ignoreElements()
  );
};
const LoadFlightsEpic = (action$, state$) => {
  return action$.pipe(
    ofType(flightActionTypes.LOAD_FLIGHTS),
    mergeMap((action) => {
      const { payload } = action;
      return of(LoadFlightsObservable(action.payload, state$)).pipe(mergeMap((x) => x)).startWith(loadingFlights(payload.id));
    })
  );
};
const LoadFlightsObservable = (payload, state$) => {
  const { id, managementGroup, flights, workspaceId } = payload;
  let count = 1;
  let errorMessage = null;
  return from(flights).pipe(
    mergeMap((name) => {
      return innerLoadLoadingLoadedEpic({
        state$,
        payload: name,
        loadResource: (name2) => FeatureResources.getFlight(name2, managementGroup, workspaceId, false),
        loadingAction: (name2) => loadingFlight(id, name2),
        skiploadDataTransform: true,
        // @ts-ignore
        loadedAction: (flight, name2, error) => {
          var _a;
          let flightDto = flight.isSuccessful() ? flight.getSuccessData() : null;
          if (!flightDto) {
            errorMessage = error;
            flightDto = {
              Name: name2,
              Description: "",
              IsolationGroups: [...flight.isSuccessful() ? [] : ["Error loading isolation groups"]]
            };
          }
          let actions = [
            loadedFlight(id, name2, { data: flightDto, status: AsyncRequestStatus.Completed }, (_a = flight == null ? void 0 : flight.errorContext) == null ? void 0 : _a.displayError)
          ];
          if (count === flights.length) {
            actions.push(loadedFlights(payload.id, errorMessage));
          }
          count++;
          return from(actions);
        }
      });
    })
  );
};
const flightsEpics = combineEpics(LoadFlightsEpic);
export {
  FlightErrorEpic,
  LoadFlightsEpic,
  flightsEpics
};
//# sourceMappingURL=FlightsEpics.js.map
